export class GroupRepository {

    static getAll() {
        return JSON.parse(localStorage.getItem("groups"));
    }

    static find(id) {
        if (this.getAll() === null) return null

        let find;

        this.getAll().forEach(function (item) {
            if (item.id === id) {
               find =  item
            }
        })


        return find
    }

    static findByChatId(chatId) {
        if (this.getAll() === null) return null

        let find;
         this.getAll().forEach(function (item) {

            if (parseInt(item.chat_id) === parseInt(chatId)) {
               find=  item
            }
        })

        return find
    }

    static deleteAll() {
        return localStorage.removeItem("groups")
    }

    static saveGroups(groups) {
        localStorage.setItem("groups", JSON.stringify(groups))
    }
}
